import { render, staticRenderFns } from "./event-list.vue?vue&type=template&id=224073a0&scoped=true"
import script from "./event-list.vue?vue&type=script&lang=js"
export * from "./event-list.vue?vue&type=script&lang=js"
import style0 from "./event-list.vue?vue&type=style&index=0&id=224073a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224073a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224073a0')) {
      api.createRecord('224073a0', component.options)
    } else {
      api.reload('224073a0', component.options)
    }
    module.hot.accept("./event-list.vue?vue&type=template&id=224073a0&scoped=true", function () {
      api.rerender('224073a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/event/event-list.vue"
export default component.exports